import { getResponseErrorStatusCode } from '../../../../utils/get-response-error-status-code';
export var EmailAvailabilityErrorCodeV1;
(function(EmailAvailabilityErrorCodeV1) {
    EmailAvailabilityErrorCodeV1[EmailAvailabilityErrorCodeV1[/**
     * Incorrect email format error.
     */ "InvalidEmailFormat"] = 30009] = "InvalidEmailFormat";
})(EmailAvailabilityErrorCodeV1 || (EmailAvailabilityErrorCodeV1 = {}));
export class EmailAvailabilityErrorV1 extends Error {
    constructor(errorCode){
        const error = `Failed to validate email availability. API error code ${errorCode}: ${EmailAvailabilityErrorCodeV1[errorCode]}`;
        super(error);
        this.errorCode = errorCode;
    }
}
export async function getEmailAvailabilityErrorV1(error) {
    if (getResponseErrorStatusCode(error) === 400) {
        return new EmailAvailabilityErrorV1(30009);
    }
    return error;
}

//# sourceMappingURL=email-availability-error.js.map